import { ListItem, ListItemText } from "@material-ui/core";
import React from "react";
import { Link } from "react-router-dom";
import { LINK_TYPE_EXTERNAL } from "../menus";

const MenuItem = ({ title, onClick, link, linkType }) => {
  if (linkType === LINK_TYPE_EXTERNAL) {
    return (
      <a
        style={{ textDecoration: "none" }}
        rel="noopener noreferrer"
        target="_blank"
        href={link}
      >
        <ListItem button onClick={onClick}>
          <ListItemText primary={title} />
        </ListItem>
      </a>
    );
  }

  return (
    <div onClick={onClick}>
      <ListItem button component={Link} to={link}>
        <ListItemText primary={title} />
      </ListItem>
    </div>
  );
};

export default MenuItem;
